import React from 'react';
import './App.css';
import ImageUploader from './components/ImageUploader';
import StyleSelector from './components/StyleSelector';
import ResultViewer from './components/ResultViewer';
import Header from './components/Header';
import Footer from './components/Footer';
import { useState } from 'react';
import axios from 'axios';

function App() {
  const [currentFile, setCurrentFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [selectedStyle, setSelectedStyle] = useState(null);
  const [isConverting, setIsConverting] = useState(false);
  const [conversionProgress, setConversionProgress] = useState(0);
  const [conversionStatus, setConversionStatus] = useState('');
  const [originalImageUrl, setOriginalImageUrl] = useState('');
  const [resultImageUrl, setResultImageUrl] = useState('');
  const [showResult, setShowResult] = useState(false);
  const [resultTitle, setResultTitle] = useState('');
  const [error, setError] = useState('');

  // 处理图片上传
  const handleFileSelect = (file) => {
    setCurrentFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  // 处理移除图片
  const handleRemoveImage = () => {
    setCurrentFile(null);
    setPreviewUrl('');
  };

  // 处理风格选择
  const handleStyleSelect = (style) => {
    setSelectedStyle(style);
  };

  // 根据风格获取配置
  const getStyleConfig = (style) => {
    const configs = {
      ghibli: {
        prompt: "把这张图片转绘成吉卜力风格，主题、背景等画面元素全部保持一致",
        title: "吉卜力风格",
        filename: "ghibli_style.jpg"
      },
      pixel: {
        prompt: "把这张图片转绘成像素风格，保持8位像素游戏的复古感，主题、背景等画面元素全部保持一致",
        title: "像素风格",
        filename: "pixel_style.jpg"
      },
      sketch: {
        prompt: "把这张图片转绘成铅笔素描风格，使用精细的线条和阴影，主题、背景等画面元素全部保持一致",
        title: "铅笔素描风格",
        filename: "sketch_style.jpg"
      }
    };
    
    return configs[style] || configs.ghibli;
  };

  // 处理图片转换
  const handleConvertImage = async () => {
    if (!currentFile || !selectedStyle) {
      setError('请选择图片和转换风格！');
      return;
    }
    
    try {
      setError('');
      setIsConverting(true);
      setConversionProgress(10);
      setConversionStatus('准备转换...');
      setShowResult(true);
      setOriginalImageUrl(previewUrl);
      
      // 获取风格配置
      const styleConfig = getStyleConfig(selectedStyle);
      setResultTitle(styleConfig.title);

      // 准备表单数据
      const formData = new FormData();
      formData.append('image', currentFile);
      formData.append('style', selectedStyle);
      formData.append('prompt', styleConfig.prompt);

      // 发送请求到后端API
      setConversionProgress(30);
      setConversionStatus('正在上传图片...');
      
      const response = await axios.post('https://ai-style-converter-api.onecuber1.workers.dev/api/convert', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      // 更新进度
      setConversionProgress(100);
      setConversionStatus('转换完成！');

      // 检查响应中是否包含图片URL
      if (response.data && response.data.imageUrl) {
        setResultImageUrl(response.data.imageUrl);
      } else {
        throw new Error('未接收到图片URL');
      }
    } catch (error) {
      console.error('转换过程中出错:', error);
      setError(`转换失败: ${error.message}`);
      setConversionProgress(0);
      setConversionStatus('转换失败');
    } finally {
      setIsConverting(false);
    }
  };

  return (
    <div className="app">
      <div className="container">
        <Header />

        <main>
          <div className="upload-section">
            <ImageUploader 
              previewUrl={previewUrl} 
              onFileSelect={handleFileSelect} 
              onRemoveImage={handleRemoveImage} 
            />
            
            <StyleSelector 
              selectedStyle={selectedStyle} 
              onStyleSelect={handleStyleSelect} 
            />
            
            <button 
              className="convert-button" 
              disabled={!currentFile || !selectedStyle || isConverting}
              onClick={handleConvertImage}
            >
              {isConverting ? '处理中...' : '转换图片'}
            </button>
            
            {error && <div className="error-message">{error}</div>}
          </div>

          {showResult && (
            <ResultViewer 
              originalImageUrl={originalImageUrl}
              resultImageUrl={resultImageUrl}
              isConverting={isConverting}
              progress={conversionProgress}
              status={conversionStatus}
              resultTitle={resultTitle}
            />
          )}
        </main>

        <Footer />
      </div>
    </div>
  );
}

export default App; 
